// Ready-made i18next init options for the METIS Hub wording. The package itself does not import i18next (pure data and
// functions); the app does: i18next.use(mockupFormatter).use(initReactI18next).init(i18nextInitOptions(lang)).
import { INTERPOLATION_OPTIONS, missingInterpolationHandler } from './interpolation.js';
import { DEFAULT_NS, LANGS, NAMESPACES, RESOURCES, type Lang } from './resources.js';

export function i18nextInitOptions(lng: Lang) {
  return {
    resources: RESOURCES as unknown as Record<string, Record<string, Record<string, string>>>,
    lng,
    // The mockup falls back to Korean when an English string is missing.
    fallbackLng: 'ko',
    supportedLngs: [...LANGS] as string[],
    ns: [...NAMESPACES] as string[],
    defaultNS: DEFAULT_NS as string,
    // Every key is unique across namespaces, so t('stats.title') finds it wherever it lives.
    fallbackNS: NAMESPACES.filter((n) => n !== DEFAULT_NS) as string[],
    // Keys are flat strings with dots ('nav.home'), never nested paths or "ns:key".
    keySeparator: false as const,
    nsSeparator: false as const,
    interpolation: { ...INTERPOLATION_OPTIONS },
    missingInterpolationHandler,
    returnNull: false,
    initAsync: false,
  };
}
